import ProjectsHeader from '@app/ProjectsHeader/ProjectsHeader.vue';

export default function install(Vue) {
  Vue.component('ProjectsHeader', ProjectsHeader)
}
